import { render, staticRenderFns } from "./TableImageIconWithCounter.vue?vue&type=template&id=ccbaa74a&scoped=true"
import script from "./TableImageIconWithCounter.vue?vue&type=script&lang=js"
export * from "./TableImageIconWithCounter.vue?vue&type=script&lang=js"
import style0 from "./TableImageIconWithCounter.vue?vue&type=style&index=0&id=ccbaa74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbaa74a",
  null
  
)

export default component.exports